import React, {useState} from 'react';
import {Box, CardContent, Paper, Typography, Unstable_Grid2 as Grid} from '@mui/material';
import {
    DndContext,
    closestCorners,
    MouseSensor,
    TouchSensor,
    DragOverlay,
    useSensor,
    useSensors, PointerSensor,
    // LayoutMeasuringStrategy,
} from '@dnd-kit/core';
import {SortableContext, arrayMove, rectSwappingStrategy} from '@dnd-kit/sortable';

import SortableItem from "./SortableItem";
import {generateUUIDv4} from "@/modules/MuiDialog/utils/uuid";
import SquareImageViewBox from "@/components/common/SquareImageViewBox";

const DragAndDrop = () => {
    // const [items] = useState([1, 2, 3]);
    const [items, setItems] = useState([
        `https://picsum.photos/id/125/600/600`,
        `https://picsum.photos/id/225/600/600`,
        `https://picsum.photos/id/350/600/600`,
        `https://picsum.photos/id/450/600/600`,
        `https://picsum.photos/id/550/600/600`,
        `https://picsum.photos/id/650/600/600`,
        `https://picsum.photos/id/425/600/600`,
        `https://picsum.photos/id/525/600/600`,
    ]);

    const [activeItem, setActiveItem] = useState(null)

    const sensors = useSensors(useSensor(PointerSensor, {
        activationConstraint: {
            distance: 8,
        },
    }), useSensor(MouseSensor), useSensor(TouchSensor));

    function handleDragStart(event:any) {
        setActiveItem(event.active.id);
    }

    function handleDragOver(event:any) {
        const { active, over } = event;

        if (active.id !== over.id) {
            setItems((items) => {
                const oldIndex = items.indexOf(active.id);
                const newIndex = items.indexOf(over.id);

                return arrayMove(items, oldIndex, newIndex);
            });
        }
    }

    function handleDragEnd(event:any) {
        setActiveItem(null);
    }

    function handleDragCancel() {
        setActiveItem(null);
    }

    return (
        <div>
            <Typography variant={'h1'} gutterBottom>Drag And Drop</Typography>


            <Box sx={{my: 3}}>
                <Typography variant={'h2'} gutterBottom>Sortable Draggable List/Grid</Typography>
                <Paper variant={'outlined'}>
                    <CardContent className={'text-center'}>
                        <Grid container>
                            <DndContext sensors={sensors}
                                        collisionDetection={closestCorners}
                                        onDragStart={handleDragStart}
                                        onDragOver={handleDragOver}
                                        onDragEnd={handleDragEnd}
                                        onDragCancel={handleDragCancel}>
                                <SortableContext items={items} strategy={rectSwappingStrategy}>

                                    {items.map( (item, index) => (
                                        <Grid xs={2} key={item}>
                                            <SortableItem id={item} isActive={item === activeItem}>
                                                <SquareImageViewBox isLabeled={index === 0} src={item} />
                                            </SortableItem>
                                        </Grid>
                                    ) )}

                                </SortableContext>

                                <DragOverlay adjustScale={false}>
                                    {activeItem ? (
                                        <div
                                            style={{
                                                display: "grid",
                                                gridAutoColumns: "auto",
                                                gridAutoRows: "auto",
                                                height: "100%"
                                            }}
                                        >
                                            <SortableItem>
                                                <SquareImageViewBox src={activeItem} />
                                            </SortableItem>
                                        </div>
                                    ) : null}
                                </DragOverlay>

                            </DndContext>

                            <Grid xs={2}>
                                <div>test</div>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Paper>
            </Box>

        </div>
    );
}


export default DragAndDrop;